import { BadgeInfo } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export default function AboutHeader() {
  const { theme } = useTheme();

  return (
    <section className="rounded-lg border bg-white p-6 shadow-sm sm:p-8" style={{ borderColor: theme.border, backgroundColor: theme.surface }}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-lg" style={{ backgroundColor: theme.primary }}>
          <BadgeInfo className="h-7 w-7" style={{ color: theme.contrastText }} />
        </div>
        <div>
          <h1 className="mb-2 text-3xl font-bold tracking-normal" style={{ color: theme.text }}>
            ISentryx
          </h1>
          <p className="mb-0 text-base leading-7" style={{ color: theme.textSecondary }}>
            Enterprise Skill Discovery, Collaboration and Community Platform
          </p>
        </div>
      </div>
    </section>
  );
}
